import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import WhatsappTemplatesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'whatsapp_templates_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'whatsapp_templates_list',
          meta: {
            permissions: [...ROLES],
            fullWidth: true,
          },
          component: WhatsappTemplatesHome,
        },
      ],
    },
  ],
};
